/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelTablePropertyList.ts                 *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "common/table-property";

export class AutogenModelTablePropertyList<RowType extends ModelRow> extends Endpoint<RowType, RowTablePropertyFieldsList> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowTablePropertyList extends ModelRow<RowTablePropertyFieldsList> {
	constructor(values?: Partial<RowTablePropertyFieldsList>) {
		super(endpointPath, true, values);
	}
}

export interface RowTablePropertyFieldsList {
	audit_size: number;
	company_id: string;
	is_audited: string;
	is_audited_delete: string;
	is_audited_insert: string;
	is_audited_update: string;
	is_broadcasted: string;
	is_query_restrict: string;
	is_shared: string;
	keep_last_audit: string;
	table_name: string;
}

